import { List, Record } from 'immutable'

import ActionTypes from '../constants/action-types'
import CompanyFeature from '../model/companyFeature'
import { ReducerAction } from '../utils/reducer-utils'

export interface CompanyFeatureReducer {
  companyID: string | undefined // keeping track of the active company by listening on COMPANY_SETTING_ACTIVE
  loading: boolean
  loaded: boolean
  saving: boolean
  companyFeatures: List<CompanyFeature>
  error: Error | null
}

const Params = Record<CompanyFeatureReducer>({
  companyID: undefined, // keeping track of the active company by listening on COMPANY_SETTING_ACTIVE
  loading: false,
  loaded: false,
  saving: false,
  companyFeatures: List<CompanyFeature>(),
  error: null,
})

export interface CompanyFeatureAction extends ReducerAction {
  companyID?: string
  companyFeatures?: CompanyFeature[]
  companyFeature?: CompanyFeature
  companyFeatureID?: string
}

export default (
  state: Record<CompanyFeatureReducer> = Params(),
  action: CompanyFeatureAction = { type: '' }
): Record<CompanyFeatureReducer> => {
  // keep track of the active company
  if (action.type === ActionTypes.COMPANIES_SETTING_ACTIVE || action.type === ActionTypes.COMPANIES_LOADED) {
    return Params({
      companyID: action.companyID,
    })
  }
  // only process actions for the active company
  if ('companyID' in action && action.companyID !== state.get('companyID')) {
    return state
  }

  let idx = -1
  switch (action.type) {
    case ActionTypes.COMPANY_FEATURES_LOADING:
      return Params({
        companyID: state.get('companyID'),
        loading: true,
      })
    case ActionTypes.COMPANY_FEATURES_LOADED:
      return Params({
        companyID: state.get('companyID'),
        loaded: true,
        companyFeatures: List<CompanyFeature>(action.companyFeatures),
      })
    case ActionTypes.COMPANY_FEATURES_LOAD_FAILED:
      return Params({
        companyID: state.get('companyID'),
        error: action.error,
      })

    case ActionTypes.COMPANY_FEATURE_ADDED:
      if (!action.companyFeature) {
        return state
      }
      idx = state
        .get('companyFeatures')
        .findIndex((item) => !!action.companyFeature && item.id === action.companyFeature.id)
      if (idx !== -1) {
        return state.set('companyFeatures', state.get('companyFeatures').set(idx, action.companyFeature))
      }
      return state.set('companyFeatures', state.get('companyFeatures').push(action.companyFeature))
    case ActionTypes.COMPANY_FEATURE_DELETED:
      idx = state.get('companyFeatures').findIndex((item) => item.id === action.companyFeatureID)
      if (idx === -1) {
        return state.set('saving', false)
      }
      return state.set('saving', false).set('companyFeatures', state.get('companyFeatures').delete(idx))

    case ActionTypes.USER_LOGGED_OUT:
      return Params()
    default:
      return state
  }
}
